export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
      } else {
        reject(new Error('Failed to convert file to base64'));
      }
    };
    reader.onerror = error => reject(error);
  });
};

// Helper to strip the data URL prefix (e.g., "data:image/png;base64,")
export const stripBase64Prefix = (base64String: string): string => {
  return base64String.split(',')[1] || base64String;
};
